import defaultTo from "lodash/defaultTo";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import { MenuItem } from "../../../types/Menu";

export const isActive = (currentPath: string, item?: MenuItem): boolean => includes(currentPath, item?.title);

export const getBorderBottom = (currentPath: string, item: MenuItem): string =>
  isActive(currentPath, item) || !isEmpty(item.baseColor) ? "2px solid" : "";

export const getMarginBottom = (currentPath: string, item: MenuItem): string => (isActive(currentPath, item) ? "-2px" : "");

export const getBorderColor = (currentPath: string, item: MenuItem): string =>
  isActive(currentPath, item) ? item.highlightColor : defaultTo(item.baseColor, "");
